<div class="container">
  <form class="form" (ngSubmit)="onCrearTareaSubmit()" [formGroup]="newTaskFormGroup">
    <div class="row">
      <div class="col-md-4">
        <app-tree-autocomplete [dptos]="departamentos" (onSelected)="trackDepartamentoChanges($event)" class="full-width"/>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Servidor p&uacute;blico</mat-label>
          <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
            (focus)="selectAllText($event)">
          <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn">
            @for (participante of participantesFiltered | async; track participante) {
            <mat-option [value]="participante" style="display: block;">
                <div><span>{{participante.apellidos.trim()+" "+participante.nombres.trim()}}</span> </div>
                <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
                <span class="sgd-spacer"></span>
                <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}" style="float: inline-end; margin-right: 0;">boy</mat-icon>
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Fecha m&aacute;xima</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="maxDate" [min]="minDate">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <mat-label>Sumilla/Comentario</mat-label>
          <textarea matInput placeholder="Sumilla o comentario" formControlName="comment"></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-12" style="display: flex; gap: 1rem;">
        <button class="full-width" mat-button type="button" (click)="onCancel()">
          Cancelar
        </button>
        <button class="full-width" [disabled]="!newTaskFormGroup.valid || fetchingNewTask" mat-flat-button
          type="submit">
          <div>
            @if (fetchingNewTask) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Crear</p>
            }
          </div>
        </button>
      </div>
    </div>
  </form>
  <app-table-selected-documents [documentsInformation]="documentsInformation"></app-table-selected-documents>
</div>
